import { render, staticRenderFns } from "./ContentLoaderBookingMessageMobile.vue?vue&type=template&id=a7b88d5c&"
import script from "./ContentLoaderBookingMessageMobile.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderBookingMessageMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports